export default __webpack_public_path__ + "static/media/percent_num.eeaf9bb5.svg";